import get from 'lodash/get';

import environment from 'environment';
import makeRequest from './makeRequest';
import makeCloudFunctionRequest from './makeCloudFunctionRequest';

export * from './macroArticleQueries';

export const getMacrosForAccount = async (simplrAccountId) => {
  return makeCloudFunctionRequest('getMacrosForAccount', {
    simplrAccountId,
  });
};

export async function fetchChatMacros({ brand, conversationId, simplrAccountPtrId }) {
  const response = await makeRequest(environment.services.chatMLUrl, {
    method: 'post',
    data: {
      brand,
      conversation_id: conversationId,
      simplr_account_id: simplrAccountPtrId,
    },
  });

  return {
    canDisplayMacros: get(response, 'toDisplay', false),
    mlRecommendedMacros: get(response, 'macros_recommended', []),
    defaultSelectedMacro: get(response, 'macros_recommended[0]', {}),
    originalResponseData: response,
  };
}
